import { ComponentProps } from 'react';
import { bordColorTheme } from 'styles/styles.constants';

/**
 * Icono de solicitud de pago para BordOneToneIcon
 */
const BordPaymentRequestIcon = ({ stroke }: ComponentProps<'svg'>) => {
  return (
    <svg viewBox="0 0 6 11" fill="none">
      <path
        d="M2.79733 8.92317C4.06661 8.92317 5.09467 8.06627 5.09467 7.00949C5.09467 5.95272 4.06661 5.09467 2.79733 5.09467C1.52806 5.09467 0.5 4.23776 0.5 3.17984C0.5 2.12307 1.52806 1.26616 2.79733 1.26616M2.79733 8.92317C1.52806 8.92317 0.5 8.06627 0.5 7.00949M2.79733 8.92317V9.68933M2.79733 1.26616V0.5M2.79733 1.26616C4.06661 1.26616 5.09467 2.12307 5.09467 3.17984"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeLinecap="round"        
      />
    </svg>
  );
};

export default BordPaymentRequestIcon;
